<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-row>
        <b-col>
          <pos-category-list :showMeal="showMeal" :showPrasad="showPrasad" :showBhaint="showBhaint" :systemid="3"></pos-category-list>
        </b-col>
      </b-row>
    </b-card>
  </div?>
</template>
<script>
  import Vue from 'vue'
  import PosCategoryList from './components/PosCategoryList'
  export default{
    name: 'BhandargharCategories',
    components: {
      'pos-category-list': PosCategoryList,
    },
    data: function() {
      return {
        showMeal: true,
        showPrasad: true,
        showBhaint: false

      }
    },
    methods: {},
    created: function(){},


  }

</script>
